import React from "react";

import PropTypes from "prop-types";
import { isFunction } from "underscore";
import classNames from "classnames";
import Avatar from "../elements/avatar";

const ContactDisplayCard = ({ contact, ...props }) => {
  const renderLink = component => {
    const link = props.link || `/contact/${contact != null ? contact.id : undefined}`;

    if (!props.showNameLink || !(contact != null ? contact.id : undefined)) {
      return component;
    } else {
      return (
        <a href={link} data-refer={props.referrer} target={props.target}>
          {component}
        </a>
      );
    }
  };

  const isDeceased = contact.properties && contact.properties.deceased ? contact.properties.deceased.value : null;
  return (
    <div
      className={classNames("et--contact-card", props.className)}
      onClick={props.onClick}
      onMouseOver={props.onMouseOver}
      onMouseOut={props.onMouseOut}
    >
      <div className={classNames("et--contact-card--body fs-exclude-data", { "is-stacked": props.isStacked })}>
        {contact.avatar && isFunction(props.avatar)
          ? this.props.avatar(contact.avatar, this.props.avatarSize, "et--contact-card--avatar")
          : renderLink(<Avatar className="et--contact-card--avatar" url={contact.avatar} width={props.avatarSize} />)}
        <div
          className="et--contact-card--content"
          style={{
            width: `calc(100% - ${props.avatarSize}px)`,
            verticalAlign: props.align,
          }}
        >
          <div className={classNames("et--contact-card--name", { "is-deceased": isDeceased })}>
            {renderLink(<strong>{props.formattedName}</strong>)}
            {isDeceased ? <span className="et--contact-card--deceased">Deceased</span> : undefined}

            {props.showClassYear ? <div className="et--contact-card--class">{props.roleWithYear}</div> : undefined}
            {props.children ? <div className="et--contact-card--children">{props.children}</div> : undefined}
          </div>
        </div>
      </div>
    </div>
  );
};

ContactDisplayCard.propTypes = {
  contact: PropTypes.object,
  link: PropTypes.string,
  align: PropTypes.string,
  avatarSize: PropTypes.number,
  showClassYear: PropTypes.bool,
  showNameLink: PropTypes.bool,
  referrer: PropTypes.string,
  onMouseOver: PropTypes.func,
  onMouseOut: PropTypes.func,
  onClick: PropTypes.func,
  isStacked: PropTypes.bool,
  target: PropTypes.string,
};

ContactDisplayCard.defaultProps = {
  showClassYear: true,
  showNameLink: true,
  avatarSize: 56,
  align: "middle",
  target: "_self",
};

export default ContactDisplayCard;
